import React, { useEffect } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import products from "../../../../../providers/Products";
import StorageHandler from "../../../../../utils/StorageHandler";
import NewHeadline from "../../../../shared/NewHeadline";
import useCalulatorStore from "../../CalculatorPage/store";
import useStepProductChoiceStore from "./store";

const ProductContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 40px;
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const ProductBox = styled.div`
    padding: 20px;
    color: ${({ theme }) => theme.colors.blue.toString()};
    text-align: center;
    border: 2px solid ${({ theme }) => theme.colors.darkGrey.toString()};
    border-radius: 4px;

    &:hover {
        cursor: pointer;
        filter: brightness(85%);
    }
`;

const ProductName = styled.div`
    font-size: 1.5rem;
`;

const StepProductChoice = () => {
    const theme = useTheme();

    const isSelected = css`
        color: white;
        background-color: ${theme.colors.red.toString()};
        border-color: ${theme.colors.red.toString()};
    `;

    const storage = new StorageHandler();

    const [productIsPremium, setProductIsPremium, productHasChanged] =
        useStepProductChoiceStore((state) => [
            state.productIsPremium,
            state.setProductIsPremium,
            state.productHasChanged,
        ]);

    const [additions] = useCalulatorStore((state) => [state.additions]);

    const premiumInStore = storage.getBoolean("hel:product-is-premium");

    useEffect(() => {
        storage.set("hel:gtag:subject", "product-choice");
        storage.set("hel:gtag:initial-value", premiumInStore);
        storage.set("hel:gtag:current-value", premiumInStore);
    }, []);

    /**
     * When the product changes.
     *
     * @param {*} value
     */
    const onChange = (value) => {
        setProductIsPremium(value);
        productHasChanged();
    };

    useEffect(() => {
        setProductIsPremium(productIsPremium);
        storage.set("hel:gtag:current-value", productIsPremium);
    }, [productIsPremium]);

    return (
        additions && (
            <section>
                <NewHeadline>Heizölsorte</NewHeadline>
                <strong>Welche Heizölsorte haben Sie im Tank?</strong>
                <p>
                    87 Prozent unserer Kunden verwenden unser Premium-Heizöl.
                    Wenn Sie bereits Premium in Ihrem Tank haben, empfehlen wir,
                    wieder Premium-Heizöl nachzutanken.
                </p>

                <ProductContainer>
                    {products.map((product, index) => {
                        const selected =
                            product.premiumVal === productIsPremium;

                        return (
                            <ProductBox
                                key={`p${index}`}
                                css={selected ? isSelected : ""}
                                onClick={() => {
                                    onChange(product.premiumVal);
                                }}
                            >
                                <ProductName>{product.name}</ProductName>
                                <p>{product.description}</p>
                                <div>
                                    {premiumInStore &&
                                        !product.premiumVal &&
                                        `-${additions.premium_add} € pro 100l inkl. MwSt.`}
                                    {!premiumInStore &&
                                        product.premiumVal &&
                                        `+${additions.premium_add} € pro 100l inkl. MwSt.`}
                                </div>
                            </ProductBox>
                        );
                    })}
                </ProductContainer>
            </section>
        )
    );
};

export default StepProductChoice;
